import { Component, ojs, app, payload } from "modular-openscriptjs";
import { either } from "../../helpers";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

export default class AnnouncementImageView extends Component {
	render(image, index, announcement, ...args) {
		return h.div(
			{
				class: "h-100",
				onclick: this.method("click", [
					announcement,
					index,
					"home_banner",
				]),
			},

			either(index == 0, { class: "active" }),

			h.img({
				src: image.path,
				class: "d-block w-100 rounded-4 h-100",
				alt: `${announcement.name} image ${index + 1}`,
				loading: "lazy",
				style: "object-fit: cover;",
			}),

			...args,
		);
	}

	click(announcement, imageIndex, placement) {
		broker.send(
			$e.announcement.was.clicked,
			payload({ announcement, imageIndex, placement }),
		);

		if (announcement.target_type === "event") {
			try {
				broker.send(
					announcement.url,
					payload({ announcement, imageIndex, placement }),
				);
			} catch (e) {
				//
			}

			return;
		}

		const router = app("router");
		if (router.isQualifiedUrl(announcement.url)) {
			let link = h.a({
				href: announcement.url,
				target: announcement.target,
				class: "d-none",
				parent: document.body,
			});

			link.click();
		} else {
			router.to(announcement.url);
		}
	}
}

ojs(AnnouncementImageView);
